<template>
  <g id="pipe-lines-holder">
  </g>
</template>

<script>
export default {
  name: 'PipeLines',
  props: [],
};
</script>

<style scoped>
</style>